import { BaseElement, defineElement } from '@webtides/element-js';
import { triggerLinkClick } from '../../../../utils/links.js';

export default class ContentCardsOverview extends BaseElement {
    /** @type {ContentCardsOverviewSection[]} */
    sections;

    connected() {
        this.sections = Array.from(this.querySelectorAll('mb-content-cards-overview-section'));
    }

    events() {
        return {
            this: {
                click: (event) => {
                    const cardTag = event.target.closest('mb-card-tag');
                    if (cardTag) {
                        const sectionName = cardTag.getAttribute('name');

                        // TODO: for some reason the click event is fired twice...
                        if (event.target.nodeName === 'MB-TAG') {
                            const section = this.sections.find(
                                (section) => section.getAttribute('name') === sectionName,
                            );
                            if (section.cards.length === 0 && section.link.url) {
                                triggerLinkClick(section.link.url, { element: 'content cards overview' });
                            } else {
                                // TODO: find a more generic way to track these interactions
                                window.dataLayer?.push({
                                    event: 'generic',
                                    category: 'interaction',
                                    action: 'body',
                                    label: sectionName,
                                    elementName: 'content cards overview',
                                });
                            }
                        }
                    }
                },
            },
        };
    }
}

defineElement('mb-content-cards-overview', ContentCardsOverview);
